import Drawer from '@mui/material/Drawer';
import type { LegacyRef } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import type { NavButtonProps } from '../../utils/nav/NavButtonComponent';
import NavButtonComponent from '../../utils/nav/NavButtonComponent';
import NavSectionComponent from '../../utils/nav/NavSectionComponent';
import VerticalNavComponent from '../../utils/nav/VerticalNavComponent';
import PermissionDecoratorV2 from '../../utils/permission/PermissionDecoratorV2';

interface ManagementLeftNavProps {
  show?: boolean;
  onToggleClick?: () => void;
}

export const baseBackofficeNav: NavButtonProps[] = [
  {
    name: 'Projets',
    url: '/management/projects',
    itemName: 'configuration_project_tab',
  },
  {
    name: 'Sites',
    url: '/management/sites',
    itemName: 'configuration_site_tab',
  },
  //  { name: 'Surveillance', url: '/management/monitorings' }, // TODO: To be fixed
  {
    name: 'Inventaire des dispositifs de mesure',
    url: '/management/devices',
    itemName: 'configuration_devices_tab',
  },
  {
    name: 'Utilisateurs',
    url: '/management/users',
    itemName: 'configuration_users_tab',
  },
];

function LeftNavComponent(
  { show = true, onToggleClick }: ManagementLeftNavProps,
  ref: LegacyRef<HTMLDivElement>
) {
  const { t } = useTranslation('menu');
  const backofficeNav = baseBackofficeNav.map((e) => ({
    ...e,
    name: t(e.name),
  }));
  const { pathname } = useLocation();
  return (
    <Drawer
      variant="temporary"
      anchor="left"
      open={show}
      onClose={() => onToggleClick?.()}
      sx={{ width: 240, flexShrink: 0 }}
      ModalProps={{ keepMounted: true }}
    >
      <VerticalNavComponent ref={ref} id="left-nav" side="left" open={true}>
        <NavSectionComponent>
          <ul className="uk-list uk-list-collapse">
            {backofficeNav.map((elm) =>
              elm.name !== 'Capteurs' ? (
                <li key={elm.name}>
                  {elm.itemName ? (
                    <PermissionDecoratorV2 item={elm.itemName}>
                      <NavButtonComponent
                        name={elm.name}
                        url={elm.url}
                        active={pathname.includes(elm.url)}
                      />
                    </PermissionDecoratorV2>
                  ) : (
                    <NavButtonComponent
                      name={elm.name}
                      url={elm.url}
                      active={pathname.includes(elm.url)}
                    />
                  )}
                </li>
              ) : null
            )}
          </ul>
        </NavSectionComponent>
      </VerticalNavComponent>
    </Drawer>
  );
}

export default forwardRef(LeftNavComponent);
